import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import BrowseReviews from "./pages/BrowseReviews";
import SearchResults from "./pages/SearchResults";
import LoginPage from "./pages/LoginPage";
import SignUpPage from "./pages/SignUpPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import ConfirmEmailPage from "./pages/ConfirmEmailPage";
import ProfilePage from "./pages/ProfilePage";
import ActivityPage from "./pages/ActivityPage";
import ReviewPage from "./pages/ReviewPage";
import PreceptorPage from "./pages/PreceptorPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import ContentPolicyPage from "./pages/ContentPolicyPage";
import CommunityGuidelinesPage from "./pages/CommunityGuidelinesPage";
import DMCAPage from "./pages/DMCAPage";
import ContactPage from "./pages/ContactPage";
import UnsubscribePage from "./pages/UnsubscribePage";
import OpportunitiesPage from "./pages/OpportunitiesPage";
import LeaderboardPage from "./pages/LeaderboardPage";

import NotFound from "./pages/NotFound";
import ErrorBoundary from "./components/ErrorBoundary";

const queryClient = new QueryClient();

const App = () => (
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/search" element={<SearchResults />} />
            <Route path="/rotations" element={<BrowseReviews type="rotation" />} />
            <Route path="/residencies" element={<BrowseReviews type="residency" />} />
            <Route path="/fellowships" element={<BrowseReviews type="fellowship" />} />
            <Route path="/internships" element={<BrowseReviews type="internship" />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignUpPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/auth/confirm" element={<ConfirmEmailPage />} />
            <Route path="/auth" element={<LoginPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/activity" element={<ActivityPage />} />
            <Route path="/review/:id" element={<ReviewPage />} />
            <Route path="/preceptor" element={<PreceptorPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/content-policy" element={<ContentPolicyPage />} />
            <Route path="/community-guidelines" element={<CommunityGuidelinesPage />} />
            <Route path="/dmca" element={<DMCAPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/unsubscribe" element={<UnsubscribePage />} />
            <Route path="/opportunities" element={<OpportunitiesPage />} />
            <Route path="/leaderboard" element={<LeaderboardPage />} />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </ErrorBoundary>
);

export default App;
